module.exports = __webpack_public_path__ + "static/media/(V)_MG_5842_-_Cia_Termal_Beachewear_-_Moda_Feminina.946bd958.jpg";